// reporting.service.ts

import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { PerformanceReport, CommissionReport } from "./reporting.models";

@Injectable({
  providedIn: "root",
})
export class ReportingService {
  constructor(@Inject(ApiService) private api: ApiService) {}

  /**
   * Get performance report (SIM stock/activation from kaabu DB)
   * @param distributorLogin the distributor login (nom_pdg) or "ALL"
   * @param period YYYYMM format
   */
  getPerformanceReport(
    distributorLogin: string,
    period: string
  ): Observable<PerformanceReport> {
    const query = `?distributor=${encodeURIComponent(
      distributorLogin
    )}&period=${period}`;
    return this.api.get(`/common/reporting/performance${query}`) as any;
  }

  /**
   * Get commission report (legacy big data API, used by commissions.component)
   * Keeps existing behaviour so other screens continue to work.
   */
  getCommissionReport(
    distributorMsisdn: string,
    period: string,
    distributorName?: string
  ): Observable<CommissionReport> {
    let query = `?distributor=${encodeURIComponent(
      distributorMsisdn
    )}&period=${period}`;

    if (distributorName) {
      query += `&distributorName=${encodeURIComponent(distributorName)}`;
    }

    return this.api.get(`/common/reporting/commission${query}`) as any;
  }

  /**
   * Get distributors list
   */
  getDistributors(): Observable<any[]> {
    return this.api.get("/common/clients/agents") as any;
  }
}
